import { ref, getCurrentInstance } from 'vue';
import apiService from '@/services/api-comunicados';


export function useGetPaises() {
    const instance = getCurrentInstance();
    const toast = instance?.proxy.$toast;

    const paises = ref([]);
    const loadingPaises = ref(false);
    const error = ref(null);

    const cargarPaises = async() => {
        if (paises.value.length > 0 && !error.value) return;

        loadingPaises.value = true;
        error.value = null;

        try {
            const response = await apiService.getPaises();
            paises.value = response.data
        } catch (err) {
            error.value = err;
            toast.error(err.message);
        } finally {
            loadingPaises.value = false;
        }
    };

    return {
        paises,
        loadingPaises,
        error,
        cargarPaises
    };
}
